// colors.js
export const primaryColor = '#40328D'; // Azul principal
export const secondaryColor = '#4DB081'; // Verde principal
